import React from "react";
import FPNetLogo from "../../components/Logo";
import {toast} from "react-toastify";
import * as UserActions from "@commons/actions/user.action";
import {useFormUserProfile, UserForm} from "../../hooks/useFormUserProfile";
import {useAppDispatch} from "@hooks/redux-hooks/hooks";

const WaitingForActivation: React.FC = () => {
    const dispatch = useAppDispatch();

    const {user, updateUser, useFormReturn} = useFormUserProfile();
    const {handleSubmit, watch, formState: {errors}} = useFormReturn;

    const enteredEmail = watch('email');
    const sendEmail = () => {
        if (enteredEmail === user!.email) {
            dispatch(UserActions.inviaEmailAttivazione(user!)).then((res) => {
                if (res.type === UserActions.inviaEmailAttivazione.fulfilled.type) {
                    toast('Email di validazione inviata correttamente!', {type: 'success'});
                } else if (res.type === UserActions.inviaEmailAttivazione.rejected.type) {
                    toast(`Errore in invio email! ${res}`, {type: 'error'})
                }
            });
        } else
            toast(`Hai modificato l'indirizzo email! E' necessario salvare le modifiche prima di richiedere una nuova email di validazione!`);
    }

    return (
        <>
            <div className="h-full flex flex-col justify-center">
                <FPNetLogo className="mx-auto h-20 w-auto"/>
                <div className="mt-2 sm:w-full sm:max-w-2xl bg-white py-8 px-4 shadow rounded-lg sm:px-10 sm:mx-auto">
                    {/*<div className="text-white bg-orange-100 border border-orange-500 rounded-md p-2 mb-3">
                        <span className="text-orange-500"><span className="font-bold">Attenzione:</span> FPNet &egrave; in attesa della validazione dell'indirizzo di posta elettronica!<br/>
                        Ti è stata inviata un'email di validazione all'indirizzo indicato.&nbsp;
                            Verifica la tua casella di posta!<br/>
                        Se non hai ricevuto alcuna email o hai riscontrato problemi nella procedura di validazione:&nbsp;&nbsp;&nbsp;
                        </span>
                        <button onClick={() => submitInviaEmail(user?.idUser, user?.email, enteredEmail)}
                                className="text-sm justify-center rounded-md border border-transparent bg-orange-500 p-1 font-medium text-white shadow-sm
                                        hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                            Richiedi una nuova email!
                        </button>
                    </div>*/}

                    <div className="text-orange-500 bg-orange-100 border border-orange-500 rounded-md p-2 mb-3">
                        <span className="font-bold">Attenzione:</span> Il tuo account &egrave; in attesa di essere validato.&nbsp;
                        <span className="font-medium">Controlla la tua casella di posta!</span><br/>
                        Nel caso tu non abbia ricevuto nessun messaggio, controlla l'e-mail che hai inserito, oppure:&nbsp;&nbsp;&nbsp;
                        <button onClick={() => sendEmail()}
                                className="text-sm justify-center rounded-md border border-transparent bg-orange-500 p-1 font-medium text-white shadow-sm
                                        hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                            Richiedi una nuova email!
                        </button>
                    </div>

                    <form className="space-y-4" onSubmit={handleSubmit(updateUser)}>
                        <UserForm form={useFormReturn}/>
                        <div className="mt-5 pt-5 w-full border-t border-gray-200">
                            <button type="submit"
                                    className="w-full justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                                Salva
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </>)
}
export default WaitingForActivation;